<script setup>
import { onMounted, ref } from 'vue'
import AppMobileNav from '../components/layout/AppMobileNav.vue'
import AppSidebar from '../components/layout/AppSidebar.vue'
import AppTopbar from '../components/layout/AppTopbar.vue'

const SIDEBAR_STORAGE_KEY = 'dohodpro.sidebarCollapsed'
const sidebarCollapsed = ref(false)

onMounted(() => {
  sidebarCollapsed.value = window.localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true'
})

function toggleSidebar() {
  sidebarCollapsed.value = !sidebarCollapsed.value
  window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(sidebarCollapsed.value))
}
</script>

<template>
  <div class="min-h-screen bg-app-bg text-app-text">
    <a href="#main-content" class="sr-only z-[100] rounded-app-control bg-slate-950 px-4 py-3 font-bold text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4">
      Перейти к содержимому
    </a>

    <div class="mx-auto flex min-h-screen max-w-[1920px]">
      <div
        class="hidden shrink-0 transition-[width] duration-200 sm:block sm:w-sidebar-collapsed"
        :class="sidebarCollapsed ? 'lg:w-sidebar-collapsed' : 'lg:w-sidebar'"
      >
        <AppSidebar :collapsed="sidebarCollapsed" @toggle="toggleSidebar" />
      </div>

      <div class="min-w-0 flex-1">
        <AppTopbar />
        <main id="main-content" class="mx-auto w-full max-w-app px-4 pb-[calc(env(safe-area-inset-bottom,0px)+7.5rem)] pt-4 sm:px-6 sm:pb-10 sm:pt-6 lg:px-8 xl:px-10">
          <slot />
        </main>
      </div>
    </div>

    <AppMobileNav />
  </div>
</template>
